import React, { Component } from 'react';
import FuzzySearchDecorator from 'decorators/FuzzySearchDecorator';
import ValueList from 'components/ValueList';

import { withStyles } from 'styles';
import MenuItem from 'material-ui/MenuItem';
import styles from './styles';

const SearchRow = ({ text, styles, info2, info3 }) => {
    return (
        <div style={styles.row}>
            <div className="fuzzy-search-row__name" style={styles.info1}>
                {text}
            </div>
            <div style={styles.info2}>{info2}</div>
            <div style={styles.info3}>{info3}</div>
        </div>
    );
};

class MergeFuzzySearch extends Component {
    constructor(props) {
        super(props);
        const { entity } = props;
        this.AutoCompleteWrapper = FuzzySearchDecorator(entity, entity)(ValueList);
    }

    processData = (entity, styles, data) => {
        let { ignore } = this.props;

        return data.toArray().map((valueList) => {
            let text = valueList.MatchingInfo;
            let id = valueList.Id;
            let extraInfo =
                valueList.ExtraInfo && valueList.ExtraInfo !== '' ? valueList.ExtraInfo : '-';
            let extraInfo2 =
                valueList.ExtraInfo2 && valueList.ExtraInfo2 !== '' ? valueList.ExtraInfo2 : '-';
            let extraInfo3 =
                valueList.ExtraInfo3 && valueList.ExtraInfo3 !== '' ? valueList.ExtraInfo3 : '-';
            let result = null;
            switch (entity) {
                case 'companies':
                    result = (
                        <SearchRow
                            key={id}
                            text={text}
                            styles={styles}
                            info2={extraInfo}
                            info3={extraInfo3}
                        />
                    );
                    break;
                default:
                    result = <SearchRow key={id} text={text} styles={styles} />;
                    break;
            }

            return ignore !== id
                ? {
                      text: text,
                      value: <MenuItem key={id}>{result}</MenuItem>,
                  }
                : null;
        });
    };

    render() {
        const { entity, styles } = this.props;
        const AutoCompleteWrapper = this.AutoCompleteWrapper;
        return (
            <AutoCompleteWrapper
                {...this.props}
                processData={this.processData.bind(null, entity, styles)}
                removeMarginLeft={true}
            />
        );
    }
}

export default withStyles(styles)(MergeFuzzySearch);
